import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useActiveOrganization } from "./useOrganization";
import { ICreateService } from "../types/service";
import { Service } from "../services/services";

export function useCreateService() {
  const queryClient = useQueryClient();
  const org = useActiveOrganization();

  return useMutation({
    mutationFn: (data: ICreateService) =>
      Service.create({
        ...data,
        organizationId: org?.id,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
      queryClient.invalidateQueries({ queryKey: ["allocationGroups"] });
    },
  });
}

export function useUpdateService() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => {
      const { id, ...payload } = data;
      return Service.update(id, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
      queryClient.invalidateQueries({ queryKey: ["allocationGroups"] });
    },
  });
}

export function useDeleteService() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: any) => {
      return Service.delete(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
      queryClient.invalidateQueries({ queryKey: ["allocationGroups"] });
    },
  });
}